<template>
  <div class="payment-summary k-page padding-20">
    <Card class="pos-relative">
      <h3 class="text-center padding-b-20">Payment summary</h3>
      <Row type="flex" justify="space-around" class="width-50 margin-auto">
        <i-col>Submit MyRFP</i-col>
        <i-col>€100</i-col>
      </Row>
      <div class="icon-con back-icon">
        <img src="~@/assets/icons/back.svg" alt="back icon" width="40px" class="clickable" @click="handleGoBack">
      </div>
    </Card>
    <Card class="pos-relative" style="margin-top:20px">
      <div class="width-50 margin-auto payment-form padding-50">
        <!-- <div class="padding-b-20">
          <RadioGroup v-model="formData.payment_type" @on-change="handlePaymentTypeChanged">
            <Radio label="creditcard" style="margin-right:50px">Credit card</Radio>
            <Radio label="wiretransfer" disabled>Wire transfer</Radio>
          </RadioGroup>
        </div> -->

        <CreditCardForm ref="CreditCardForm" v-if="formData.payment_type == 'creditcard'" v-model="formData" @success="handleSuccess"/>
        <WireTransferForm ref="WireTransferForm" v-if="formData.payment_type == 'wiretransfer'" v-model="formData" @success="handleSuccess"/>

        <div class="text-center">
          <p v-if="!formData.is_default"><Checkbox v-model="formData.remember_card">Remember card details for next request</Checkbox></p>
          <p class="padding-b-20">Payments with Kromnix are secured.</p>
          <Button class="k-btn-1" @click="handlePayment('PaymentForm')" size="large" :loading="isLoading">Confirm Payment</Button>
        </div>
      </div>
      <Spin size="small" fix v-if="isLoading"></Spin>
    </Card>
  </div>
</template>

<script>
import { fetchPaymentMethods, addRfpsPayment } from '@/services/payments'
import CreditCardForm from './CreditCardForm'
import WireTransferForm from './WireTransferForm'

export default {
  components: {
    CreditCardForm,
    WireTransferForm
  },

  data () {
    return {
      isLoading: false,
      formData: {
        rfp: null,
        account_name: null,
        bank_name: null,
        account_number: null,
        payment_type: 'creditcard',
        card_number: null,
        expiry_date: null,
        cvc: null,
        remember_card: true,
        amount: 100
      },
      isSuccess: true
    }
  },

  async mounted () {
    this.isLoading = true
    const defaultPayment = await this.getDefaultPaymentDetails()
    if (defaultPayment) {
      this.formData = defaultPayment
      this.formData.remember_card = false
    }
    this.isLoading = false
  },

  methods: {
    async savePaymentDetails () {
      await addRfpsPayment(this.formData).then(res => {
        this.$router.push({
          name: 'rfp-form'
        })
      }).catch(err => {
        console.log('Failed to add new payment method: ', err)
        this.$Message.error({
          background: true,
          duration: 5,
          content: err.response.data.message
        })
        this.isLoading = false
      })
    },
    handlePayment () {
      if (this.formData.payment_type === 'creditcard') {
        this.$refs.CreditCardForm.handleSubmit()
      }
      if (this.formData.payment_type === 'wiretransfer') {
        this.$refs.WireTransferForm.handleSubmit()
      }

      if (this.isSuccess) {
        this.savePaymentDetails()
      }
    },

    handleGoBack () {
      this.$router.go(-1)
    },

    handleSuccess (isSuccess) {
      if (!isSuccess) this.isSuccess = isSuccess
    },

    async getDefaultPaymentDetails () {
      const d = await fetchPaymentMethods().then(res => {
        if (res.data.results.length) {
          const dPay = res.data.results.findIndex(item => item.is_default === true)
          if (dPay > -1) {
            return res.data.results[dPay]
          } else {
            return null
          }
        } else {
          return null
        }
      }).catch(err => {
        console.log('Failed to fetch default rfp payments: ', err)
      })
      return d
    },

    handlePaymentTypeChanged (val) {
      this.formData = {
        rfp: null,
        account_name: null,
        bank_name: null,
        account_number: null,
        payment_type: val,
        card_number: null,
        expiry_date: null,
        cvc: null,
        remember_card: true,
        amount: 100
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-summary {
  position: relative;
  .back-icon {
    position: absolute;
    right: 20px;
    top: 20px;
  }
}
</style>

<style lang="scss">
.payment-summary {
  .payment-form {
    label {
      padding: 0px;
    }
  }
}
</style>
